@use 'kci-design-lib/styles/variables.scss' as *;
.tooltip-container {
  position: relative;
}
.tooltip {
  padding: 0;
  [data-pc-section='text'] {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: var(--tooltip-text, var(--main-text));
    background-color: var(--tooltip-bg, var(--main-bkgd));
    box-shadow: var(--shadow-tooltip);
    border-radius: 4px;
    padding: 6px 12px;
  }
  [data-pc-section='arrow'] {
    filter: $arrow-drop-shadow;
  }
  &.tooltip-top {
    margin-top: -16px;
    &.hide-arrow {
      margin-top: -8px;
    }
    & [data-pc-section='arrow'] {
      border-top-color: var(--tooltip-bg, var(--main-bkgd));
      bottom: -8px !important; 
      left: 49% !important; 
      border-width: 8px 6px 0 6px;
    }
  }
  &.tooltip-bottom {
    margin-top: 15px;
    &.hide-arrow {
      margin-top: 8px;
    }
    [data-pc-section='arrow'] {
      border-bottom-color: var(--tooltip-bg, var(--main-bkgd));
      top: -7px !important; 
      left: 49% !important; 
      border-width: 0 6px 8px 6px;
    }
  }
  &.tooltip-left {
    margin-left: -16px;
    &.hide-arrow {
      margin-left: -8px;
    }
    [data-pc-section='arrow'] {
      border-left-color: var(--tooltip-bg, var(--main-bkgd));
      right: -8px !important; 
      top: 45% !important; 
      border-width: 6px 0 6px 8px;
    }
  }
  &.tooltip-right {
    margin-left: 15px;
    &.hide-arrow {
      margin-left: 8px;
    }
    [data-pc-section='arrow'] {
      border-right-color: var(--tooltip-bg, var(--main-bkgd));
      left: -7px !important; 
      top: 45% !important; 
      border-width: 6px 8px 6px 0;
    }
  }
}
.hide-arrow {
  [data-pc-section='arrow'] {
    display: none;
  }
}
.show-arrow {
  [data-pc-section='arrow'] {
    display: block;
  }
}
